export enum CodeReaderImportRequestStatus {
  Created = 1,
  Processing = 2,
  Completed = 3,
  ExecutionError = 4,
  PlanLimitation = 5
}
